import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { Icon, Panel } from "@culturehq/components";

import { useProfile } from "app/context";
import { Trans } from "app/utils";

import Connected from "components/person/Connected";
import ErrorBoundary from "components/common/ErrorBoundary";
import ConnectButton from "./ConnectButton";
import ConnectionUser from "./ConnectionUser";
import styles from "./styles.module.scss";
import makeSharedString from "./makeSharedString";

const BuildConnection = ({ connection }) => {
  const { profile: { organization: { name } } } = useProfile();
  const [connected, setConnected] = useState(false);
  const onConnect = useCallback(() => setConnected(true), [setConnected]);

  const handleUnfollow = useCallback(
    () => {
      setConnected(false);
    }, [setConnected]
  );

  if (connection) {
    const { user } = connection;

    return (
      <>
        <p className={styles.light}>
          {makeSharedString(connection, name)}
        </p>
        <ConnectionUser user={user}>
          {
            connected
              ? <Connected user={user} handleUnfollow={handleUnfollow} />
              : <ConnectButton connection={connection} user={user} onConnect={onConnect} />
          }
        </ConnectionUser>
      </>
    );
  }

  return null;
};

const BuildConnections = ({ connections }) => {
  const displayed = [...connections, null, null, null].slice(0, 3);

  return (
    <div className="Person--Suggested-People">
      <Panel>
        <Panel.Heading>
          <Icon icon="person-check" /><Trans>Suggested Connections</Trans>
        </Panel.Heading>
        <Panel.Body>
          <ErrorBoundary>
            {displayed.map((connection, index) => (
              <div key={connection ? connection.id : index} className="User">
                <div>
                  <BuildConnection connection={connection} />
                </div>
                {(index !== displayed.length - 1) && (<hr />)}
              </div>
            ))}
          </ErrorBoundary>
        </Panel.Body>
        <Panel.Footer>
          <Link to="/community?c=suggestions">
            <span>View all suggested connections</span>
          </Link>
        </Panel.Footer>
      </Panel>
    </div>
  );
};

export default BuildConnections;
